// extracted by mini-css-extract-plugin
module.exports = {"bookDetails":"Books_bookDetails__3h8oJ","checkInOutButton":"Books_checkInOutButton__3UDtY"};